import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import cn from 'classnames';
import { Modal } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { hideMainDialog } from '../../actions/mainUI';
import {
  MODAL_VIEW_TYPE_SHARE,
  MODAL_VIEW_TYPE_DOWNLOAD,
  MODAL_VIEW_TYPE_DYNAMIC_DOWNLOAD,
} from '../../constants/mainContentTypes';
import UMOShareLinkView from '../UMOShareLinkView';
import DownloadUsageView from '../UMODownloadView/DownloadUsageView';
import DynamicDownloadView from '../UMODownloadView/DynamicDownloadView';
import CloseIcon from '../Icons/CloseIcon';

const mapStateToProps = state => ({
  mainUI: state.mainUI,
  umoUtils: state.umoUtils,
  session: state.session,
});

const mapDispatchToProps = dispatch => ({
  dispatch: actionToDispatch => dispatch(actionToDispatch),
  hideDialog: () => dispatch(hideMainDialog()),
});

const MainDialogModal = ({ mainUI, umoUtils, session, hideDialog, dispatch }) => {
  const viewType = mainUI.get('dialogView');
  const dialogData = mainUI.get('dialogData');
  let modalBody;

  switch (viewType) {
    case (MODAL_VIEW_TYPE_SHARE):
      modalBody =
        <UMOShareLinkView data={dialogData} />;
      break;
    case (MODAL_VIEW_TYPE_DOWNLOAD):
      modalBody =
        (<DownloadUsageView
          data={dialogData}
          hideDialog={hideDialog}
          usageFields={umoUtils.get('downloadUsageFields')}
          userEmail={session.get('email')}
          dispatch={dispatch}
        />);
      break;
    case (MODAL_VIEW_TYPE_DYNAMIC_DOWNLOAD):
      modalBody =
        (<DynamicDownloadView
          data={dialogData}
          userEmail={session.get('email')}
          hideDialog={hideDialog}
          dispatch={dispatch}
        />);
      break;
    default:
      break;
  }
  return (
    <div className="message-dialog">
      <Modal
        show={!!viewType}
        dialogClassName={cn('message-dialog__overlay',
          { 'message-dialog__overlay--edit': true },
          viewType === MODAL_VIEW_TYPE_SHARE && 'message-dialog__share-view',
        )}
        onHide={hideDialog}
      >
        <CloseIcon
          width={32}
          height={32}
          onClick={hideDialog}
          className="message-dialog__close-button"
        />

        <div className="message-dialog__body">
          {modalBody}
        </div>
      </Modal>
    </div>
  );
};

MainDialogModal.propTypes = {
  mainUI: PropTypes.instanceOf(Map),
  umoUtils: PropTypes.instanceOf(Map),
  session: PropTypes.instanceOf(Map),
  hideDialog: PropTypes.func,
  dispatch: PropTypes.func,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(MainDialogModal));
